import ActionTypes from '../../actionTypes';
import API from '../../../API';
import deriveNewsGroups from '../../newsGroups/actions/deriveNewsGroups';
import { dateToUrlDate } from '../../../shared/functions';
/**
 * Action creator for the fetch newspapers GET request
 */
var fetchNewspapersDataGetRequest = function () { return ({
    type: ActionTypes.FETCH_NEWSPAPERS_GET_REQUEST,
}); };
/**
 * Action creator for the fetch newspapers GET response
 */
var fetchNewspapersDataGetResponse = function (data) { return ({
    type: ActionTypes.FETCH_NEWSPAPERS_GET_RESPONSE,
    payload: data,
}); };
/**
 * Action creator for the fetch newspapers GET invalidate
 */
var fetchNewspapersDataGetInvalidate = function (error) { return ({
    type: ActionTypes.FETCH_NEWSPAPERS_GET_INVALIDATE,
    error: error,
}); };
/**
 * Returns a function that fetches data from the newspapers API and performs
 * the subsequent dispatch operations to send the data or the error to the store.
 */
var fetchNewspapersData = function (date) { return function (dispatch) {
    dispatch(fetchNewspapersDataGetRequest());
    return API.getNewspapersForDate(date)
        .then(function (_a) {
        var _b;
        var newspapers = _a[0], newsGroups = _a[1];
        dispatch(deriveNewsGroups(newsGroups));
        dispatch(fetchNewspapersDataGetResponse((_b = {}, _b[dateToUrlDate(date)] = newspapers, _b)));
    })
        .catch(function (error) { return dispatch(fetchNewspapersDataGetInvalidate(error.message)); });
}; };
export default fetchNewspapersData;
